<match-wrapper
    label="{{ label }}"
    objectType="{{ objectType }}"
    fieldName="{{ fieldName }}"
    (onRemoveMatch)="removeMatch()"
>
    <div
        class="hdr-match"
        provideParentForm
    >
        <avi-input-container noMarginTop>
            <label
                aviLabelWithTooltip
                objectType="HdrMatch"
                fieldName="hdr"
                for="{{ 'hdr_' + matchIndex }}"
                required
            >
                {{ l10nKeys.nameInputLabel | vtranslate }}
            </label>
            <input
                id="{{ 'hdr_' + matchIndex }}"
                name="{{ 'hdr_' + matchIndex }}"
                [(ngModel)]="editable.config.hdr"
                clrInput
                placeholder="{{ l10nKeys.nameInputPlaceholder | vtranslate }}"
                regexPattern="objName"
                required
            />
        </avi-input-container>
        <div class="hdr-match__input-container">
            <label
                aviLabelWithTooltip
                objectType="HdrMatch"
                fieldName="match_criteria"
                for="{{ 'match_criteria_' + matchIndex }}"
                required
            >
                {{ l10nKeys.criteriaLabel | vtranslate }}
            </label>
            <avi-dropdown
                id="{{ 'match_criteria_' + matchIndex }}"
                name="{{ 'match_criteria_' + matchIndex }}"
                [options]="matchOperationOptions"
                [(ngModel)]="editable.config.match_criteria"
                (ngModelChange)="handleCriteriaChange()"
                placeholder="{{ l10nKeys.criteriaPlaceholder | vtranslate }}"
                required
            ></avi-dropdown>
        </div>
        <string-group-or-custom-value
            *ngIf="showValueField()"
            class="hdr-match__string-group-or-custom-value"
            [(stringGroupRefs)]="editable.config.string_group_refs"
            [(customValues)]="editable.config.value"
            id="{{ 'hdr-match_' + matchIndex + '-' + objectType }}"
            [disallowStringGroups]="disallowStringGroups"
            [disabled]="disabled"
            [noMarginTop]="true"
        ></string-group-or-custom-value>
    </div>
</match-wrapper>
